import { Check, PersonAddAlt1 } from "@mui/icons-material";
import { KeyDriveSelect } from "../../../../components/KeydriveComponents/Selects/KeyDriveSelect";
import { Box, SelectChangeEvent } from "@mui/material";
import { KeyDriveBodyMin } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { KeyDriveBodyMax } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import PrivilegeCardListing from "./PrivilegeCardListing";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { StatePrivilegesTypes } from "../WorkSpacePermissions";
import { Group } from "../../../../model/GroupModel";
import usePrivilegeName from "../../../../functions/hooks/usePrivilegeName";
import { KeyDrivePageContainer } from "../../../../components/KeydriveComponents/PageContainer/KeyDrivePageContainer";
import { KeyDrivePrimaryButton } from "../../../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";

interface IPrivilegeStateEditingGroup {
    editPermission: () => void;
    organizationGroup: Group[];
    handleGroup(e: SelectChangeEvent): void;
    newGroupSearch: string;
    setPermissionType: (set: number) => void;
    groupId: string;
    permissionType: number;
    setNewGroupSearch: (set: string) => void;
    privilegesState: {
        state: StatePrivilegesTypes;
        id: string;
        permissionType: number;
    },
    backBtn:() => void;
    isItemPage: boolean;
}

function PrivilegeStateEditingGroup({
    editPermission,
    privilegesState,
    groupId,
    handleGroup,
    newGroupSearch,
    organizationGroup,
    permissionType,
    setNewGroupSearch,
    setPermissionType,
    backBtn,
    isItemPage
}: IPrivilegeStateEditingGroup) {

    const { t } = useTranslation();
    const { privilegeName } = usePrivilegeName(permissionType);

    useEffect(() => {
        setPermissionType(privilegesState.permissionType);
        setNewGroupSearch(privilegesState.id);
    }, [groupId]);

    return (
        <KeyDrivePageContainer
            icon={<PersonAddAlt1 fontSize='large' sx={{ color: "#22638D" }} />}
            title={t("Privileges.ModifyGroup")}
            subtitle={""}
            actions={<KeyDrivePrimaryButton
                TextComponent={KeyDriveBodyMin}
                TextComponentProps={{
                    color: "",
                    needBold: false,
                    needEllipses: false,
                    text: t("Privileges.Edit")!
                }}
                startIcon={<Check />}
                onClick={editPermission}
            />}
            onClickBtnBack={(e)=>backBtn()}>
            <KeyDriveSelect<Group>
                renderItem={(item) => (
                    <Box display="flex" alignItems="center">
                        {item.name}
                        <Box ml="4px">
                            <KeyDriveBodyMin
                                text={`(${item.name!})`}
                                color="#2D2D2D"
                                needBold={false}
                                needEllipses={false}
                                opacityParams={{
                                    needOpacity: true,
                                    opacityLevel: "0.5"
                                }}
                            />
                        </Box>
                    </Box>
                )}
                keyExtract={(item) => item.id!}
                items={organizationGroup}
                onChange={handleGroup}
                value={newGroupSearch}
                label={t("AdminConsole.Group")}
                needFullWidth
            />
            <Box
                marginTop="30px"
                marginBottom="15px"
            >
                <KeyDriveBodyMax
                    color="#2D2D2D"
                    needBold
                    needEllipses={false}
                    text="Privilégios"
                />
                <KeyDriveBodyMin
                    color="#2d2d2d"
                    needBold={false}
                    needEllipses={false}
                    text={`${t("Privileges.DefineNewPrivilegeGroup")} ${privilegeName}`}
                />
            </Box>
            <PrivilegeCardListing
                setPermissionType={setPermissionType}
                permissionType={permissionType}
                isItemPrivilege={isItemPage}
            />
        </KeyDrivePageContainer>
    );
}

export default PrivilegeStateEditingGroup;